module.exports = "https://www.gc-qa.gnp.com.mx/9ab73b53a7ca8abbbbfa01ed995fcecc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/credit-card-amex.svg
// module id = 961
// module chunks = 0